module.exports = __webpack_public_path__ + "img/order-status-icon-4.0e5288c7.png";